import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import AppButton from '../../../../../components/designe/buttons/app-button/AppButton';
import ViewField from '../../../../../components/reusable/view-field/ViewField';

interface IMeasurementFieldRowProps {
  label: string;
  value: string;
  onRecordClick: () => void;
  viewItemClassName: string;
}

export default function MeasurementFieldRow({
  label,
  value,
  onRecordClick,
  viewItemClassName,
}: IMeasurementFieldRowProps) {
  const { t } = useTranslation();

  return (
    <Box display="flex" gap={1} alignItems="center">
      <Box flex={1}>
        <ViewField
          label={label}
          value={value}
          noShadow
          className={viewItemClassName}
        />
      </Box>
      <Box>
        <AppButton variant="outlined" color="primary" onClick={onRecordClick}>
          {t('settings.measurements.recordToday')}
        </AppButton>
      </Box>
    </Box>
  );
}
